import { useState, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  createTrip,
  fetchCitys,
  fetchHotels,
  updateTrip
} from "../../../../store/reducers/home/apiThunk";
import { ToastNotifyError } from "../../../CommonComponents/Toast/ToastNotify";
import { updateLoading } from "../../../../store/reducers/loader";
import { useShoppingCart } from "../../../../context/ShoppingCartContext";

export function useSearchbox(setShowCreateTrip = () =>{}, getTripDetails =()=>{}) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [cityValue, setCityValue] = useState(null);
  const [optionsHotels, setOptionsHotels] = useState([]);
  const [optionsCitys, setOptionsCitys] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmOrLarger = useMediaQuery(theme.breakpoints.up("lg"));
  const minSelectableDate = moment().add(1, "day");
  const  {isFormOpen, onClose, setIsFormOpen, isOpen, selectedProduct }= useShoppingCart();
  const reset = () => {
    setValue(null);
    setSelectedDate(null);
    setCityValue(null);
  }
  const onSubmit = async (tripId) => {
    if(!value?.id && !cityValue?.id && !selectedDate) return;
    dispatch(updateLoading(true));
    const guestUserSessionKey = localStorage.getItem("guestUserSessionKey");
        let tripPayload;
        if(guestUserSessionKey) {
          tripPayload = {
            hotel: value ? value?.id : null,
              city: cityValue ? cityValue?.id : null,
              arrival_date: selectedDate
                ? moment(selectedDate).format("YYYY-MM-DD")
                : null,
            session_id: guestUserSessionKey,
          }
        } else {
            tripPayload = {
              hotel: value ? value?.id : null,
              city: cityValue ? cityValue?.id : null,
              arrival_date: selectedDate
                ? moment(selectedDate).format("YYYY-MM-DD")
                : null,
            };
        }
    const updateTripData = {tripPayload:tripPayload, tripId:tripId}
    try {
      const response = tripId ? await dispatch(updateTrip(updateTripData)) :  await dispatch(createTrip(tripPayload));
  
      if (response?.payload?.status || response?.type === "home/update/fulfilled") {
        if (isFormOpen) {
          reset()
          setShowCreateTrip(false);
          if(selectedProduct ===null)
          onClose()
          setIsFormOpen(false)
        } else {
          reset()
          setShowCreateTrip(false);
        }
        if(getTripDetails)
        getTripDetails()
      }
    } catch (err) {
      console.error("Error creating trip:", err);
    } finally {
      dispatch(updateLoading(false));
    }
  };

  const searchHotels = async () => {
    try {
      const response = await dispatch(fetchHotels());
      const { status, data, message } = response.payload;
      if (status) {
        setOptionsHotels(data);
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error("Error fetching hotels:", error);
    }
  };

  const searchCity = async () => {
    try {
      const response = await dispatch(fetchCitys());
      const { status, data, message } = response.payload;
      if (status) {
        setOptionsCitys(data);
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  useEffect(() => {
    searchHotels();
    searchCity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    reset()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return {
    open,
    setOpen,
    value,
    setValue,
    cityValue,
    setCityValue,
    optionsHotels,
    optionsCitys,
    selectedDate,
    setSelectedDate,
    minSelectableDate,
    isSmOrLarger,
    onSubmit,
    reset
  };
}
